import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { EstadisticaIndicador } from '@/app/models/interface/estadistica-indicador.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class EstadisticaIndicadorService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'estadistica-indicador/';

  create(data: Partial<EstadisticaIndicador>) {
    return this.http
      .post<CustomResponse<EstadisticaIndicador>>(this.url, data)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<EstadisticaIndicador[], HasPagination>>
      >(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            const data = d.data.map((d) => ({
              ...d,
              tipoKPI: d.estadisticaIndicadorKPI?.map((kpi) => kpi.kpi) || [],
            }));
            return {
              ...d,
              data,
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<EstadisticaIndicador>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
          tipoKPI: d.estadisticaIndicadorKPI?.map((kpi) => kpi.kpi) || [],
        };
      }),
    );
  }

  update(tipo: Partial<EstadisticaIndicador>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<EstadisticaIndicador>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<EstadisticaIndicador>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }
}
